import { NAME } from './constants';

export const getForecasts = state => state[NAME].forecasts;
export const getForecastKpis = state => state[NAME].forecastKPIS;
export const getForecastCreatable = state => state[NAME].forecastCreatable;
export const getForecastProjections = state => state[NAME].projections;
export const getForecastDetail = state => state[NAME].forecastDetail;
